import Layout from "../components/Layout";
import { useLayoutEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PdtsProvider, usePdtsContext } from "../context/PdtsContext";

import product_1 from "../../assets/websitePictures/Endure Series/Premier-bedding.jpg";

import { useCartContext } from "../context/CartContext";

// import "../../assets/niceshop/vendor/bootstrap/css/bootstrap.min.css";
// import "../../assets/niceshop/vendor/bootstrap-icons/bootstrap-icons.css";
// import "../../assets/niceshop/vendor/swiper/swiper-bundle.min.css";
// import "../../assets/niceshop/vendor/aos/aos.css";
// import "../../assets/niceshop/vendor/glightbox/css/glightbox.min.css";
// import "../../assets/niceshop/vendor/drift-zoom/drift-basic.css";
// import "../../assets/niceshop/css/main.css";


function ProductDetailsContent({}){
  const [cases, setCases] = useState(1);
  const { pdtCategories, products, productsById } = usePdtsContext();
  const {id} = useParams();
  const pdt = productsById[id] || {};

  const { addItem } = useCartContext();

  // useLayoutEffect(()=>{
  //   const ss = [
  //     "/build/js/niceshop/vendor/bootstrap/js/bootstrap.bundle.min.js",
  //     "/build/js/niceshop/vendor/php-email-form/validate.js",
  //     "/build/js/niceshop/vendor/swiper/swiper-bundle.min.js",
  //     "/build/js/niceshop/vendor/aos/aos.js",
  //     "/build/js/niceshop/vendor/glightbox/js/glightbox.min.js",
  //     "/build/js/niceshop/vendor/drift-zoom/Drift.min.js",
  //     "/build/js/niceshop/vendor/purecounter/purecounter_vanilla.js"      
  //   ].map(src=>{
  //     const s=document.createElement("script");
  //     s.src=src;
  //     // s.src="/assets/niceshop/vendor/drift-zoom/Drift.min.js";
  //     s.async=true;
  //     document.body.appendChild(s);
  //     return s;
  //   })

  //   return ()=>{
  //     ss.forEach(s=>document.body.removeChild(s));
  //   };
  //  },[]);

  return <><div className="page-title light-background">
        <div className="container d-lg-flex justify-content-between align-items-center">
          <h1 className="mb-2 mb-lg-0">Product Details</h1>
          <nav className="breadcrumbs">
            <ol>
              <li><a href="index.html">Home</a></li>
              <li className="current">Product Details</li>
            </ol>
          </nav>
        </div>
      </div>
      {/* <!-- End Page Title --> */}

      {/* <!-- Product Details Section --> */}
      <section id="product-details" className="product-details section">
        <div className="container" data-aos="fade-up" data-aos-delay="100">

          <div className="row g-4">
            {/* <!-- Product Gallery --> */}
            <div className="col-lg-7" data-aos="zoom-in" data-aos-delay="150">
              <div className="product-gallery">
                <div className="main-showcase">
                  <div className="image-zoom-container">
                    <img src={((pdt.images||[])[0]||{}).url}
                      alt="Product Main"
                      className="img-fluid main-product-image drift-zoom"
                      id="main-product-image"
                      data-zoom={((pdt.images||[])[0]||{}).url}
                    />

                    <div className="image-navigation">
                      <button className="nav-arrow prev-image image-nav-btn prev-image" type="button">
                        <i className="bi bi-chevron-left"></i>
                      </button>
                      <button className="nav-arrow next-image image-nav-btn next-image" type="button">
                        <i className="bi bi-chevron-right"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div className="thumbnail-grid">
                  {(pdt.images||[]).map((imgDef, idx)=><div  
                    key={idx}
                    className={"thumbnail-wrapper thumbnail-item"} data-image={imgDef.url}
                  >
                    <img src={imgDef.url} alt={`View ${idx+1}`} className="img-fluid" />
                  </div>)}

                  <div className="thumbnail-wrapper thumbnail-item active" data-image={product_1}>
                    <img src={product_1} alt="View 1" className="img-fluid" />
                  </div>
                  {/* <div className="thumbnail-wrapper thumbnail-item" data-image="assets/img/product/product-details-7.webp">
                    <img src="assets/img/product/product-details-7.webp" alt="View 2" className="img-fluid" />
                  </div>
                  <div className="thumbnail-wrapper thumbnail-item" data-image="assets/img/product/product-details-8.webp">
                    <img src="assets/img/product/product-details-8.webp" alt="View 3" className="img-fluid" />
                  </div>
                  <div className="thumbnail-wrapper thumbnail-item" data-image="assets/img/product/product-details-4.webp">
                    <img src="assets/img/product/product-details-4.webp" alt="View 4" className="img-fluid" />
                  </div>
                  <div className="thumbnail-wrapper thumbnail-item" data-image="assets/img/product/product-details-5.webp">
                    <img src="assets/img/product/product-details-5.webp" alt="View 5" className="img-fluid" />
                  </div>
                  <div className="thumbnail-wrapper thumbnail-item" data-image="assets/img/product/product-details-3.webp">
                    <img src="assets/img/product/product-details-3.webp" alt="View 6" className="img-fluid" />
                  </div> */}

                </div>
              </div>
            </div>

            {/* <!-- Product Details --> */}
            <div className="col-lg-5" data-aos="fade-left" data-aos-delay="200">
              <div className="product-details">
                {/* <div className="product-badge-container">
                  {pdt.pdtCat&&<span className="badge-category">{pdt.pdtCat}</span>}
                  <div className="rating-group">
                    <div className="stars">
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-fill"></i>
                      <i className="bi bi-star-half"></i>
                    </div>
                    <span className="review-text">(127 reviews)</span>
                  </div>
                </div> */}

                <h1 className="product-name">{pdt.name}</h1>

                <div className="pricing-section">
                  <div className="price-display">
                    <span className="sale-price">${pdt.price}</span>
                    {pdt.orgPrice&&<span className="regular-price">${pdt.orgPrice}</span>}
                  </div>
                  {/* <div className="savings-info">
                    <span className="save-amount">Save $50.00</span>
                    <span className="discount-percent">(21% off)</span>
                  </div> */}
                </div>

                <div className="product-description">
                  <p>{pdt.description}</p>
                </div>

                <div className="product-description">
                  <p>{pdt.size}</p>
                </div>

                <div className="availability-status">
                  <div className="stock-indicator">
                    <i className="bi bi-check-circle-fill"></i>
                    <span className="stock-text">Available</span>
                  </div>
                  {/* <div className="quantity-left">Only 18 items remaining</div> */}
                </div>

                {/* <!-- Product Variants --> */}
                <div className="variant-section">
                  {/* <div className="color-selection">
                    <label className="variant-label">Available Colors:</label>
                    <div className="color-grid">
                      <div className="color-chip active" data-color="Midnight Black" style={{"background": "linear-gradient(135deg, #1a1a1a, #000)"}}>
                        <span className="selection-check"><i className="bi bi-check"></i></span>
                      </div>
                      <div className="color-chip" data-color="Pearl White" style={{"background": "linear-gradient(135deg, #f8f9fa, #e9ecef)"}}>
                        <span className="selection-check"><i className="bi bi-check"></i></span>
                      </div>
                      <div className="color-chip" data-color="Ocean Blue" style={{"background": "linear-gradient(135deg, #0066cc, #004499)"}}>
                        <span className="selection-check"><i className="bi bi-check"></i></span>
                      </div>
                      <div className="color-chip" data-color="Forest Green" style={{"background": "linear-gradient(135deg, #28a745, #155724)"}}>
                        <span className="selection-check"><i className="bi bi-check"></i></span>
                      </div>
                    </div>
                    <div className="selected-variant">Selected: <span>Midnight Black</span></div>
                  </div> */}
                </div>

                {/* <!-- Purchase Options --> */}
                <div className="purchase-section">
                  <div className="quantity-control">
                    <label className="control-label">Units Price:</label>
                    <div className="quantity-input-group">
                      <span>{pdt.price}</span>
                    </div>
                  </div>
                  
                  <div className="quantity-control">
                    <label className="control-label">Units per Case:</label>
                    <div className="quantity-input-group">
                      <span>{pdt.unitsPerCase || 12}</span>
                    </div>
                  </div>

                  <div className="quantity-control">
                    <label className="control-label">Case Price:</label>
                    <div className="quantity-input-group">
                      <span>{(pdt.price * pdt.unitsPerCase).toFixed(2)}</span>
                    </div>
                  </div>

                  <div className="quantity-control">
                    <label className="control-label">Cases:</label>
                    <div className="quantity-input-group">
                      <div className="quantity-selector">
                        <button className="quantity-btn decrease" type="button"
                          onClick={evt=>setCases(prev=>Math.max(1, prev-1))}
                        >
                          <i className="bi bi-dash"></i>
                        </button>
                        <input type="number" className="quantity-input" value={cases} min="1" max="18" 
                          onChange={evt=>setCases(evt.target.value)}
                        />
                        <button className="quantity-btn increase" type="button"
                          onClick={evt=>setCases(prev=>Math.max(1, prev+1))}
                        >
                          <i className="bi bi-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="action-buttons">
                    <button className="btn primary-action"
                      onClick={evt=>pdt.unitsPerCase&&addItem(pdt, pdt.unitsPerCase * cases)}
                    >
                      <i className="bi bi-bag-plus"></i>
                      Add to Cart
                    </button>
                    {/* <button className="btn secondary-action">
                      <i className="bi bi-lightning"></i>
                      Buy Now
                    </button> */}
                    <button className="btn icon-action" title="Add to Wishlist">
                      <i className="bi bi-heart"></i>
                    </button>
                  </div>
                </div>

                {/* <!-- Benefits List --> */}
                <div className="benefits-list">
                  {/* <div className="benefit-item">
                    <i className="bi bi-truck"></i>
                    <span>Free delivery on orders over $75</span>
                  </div>
                  <div className="benefit-item">
                    <i className="bi bi-arrow-clockwise"></i>
                    <span>45-day hassle-free returns</span>
                  </div>
                  <div className="benefit-item">
                    <i className="bi bi-shield-check"></i>
                    <span>3-year manufacturer warranty</span>
                  </div>
                  <div className="benefit-item">
                    <i className="bi bi-headset"></i>
                    <span>24/7 customer support available</span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Information Tabs --> */}
          <div className="row mt-5" data-aos="fade-up" data-aos-delay="300">
            <div className="col-12">
              <div className="info-tabs-container">
                <nav className="tabs-navigation nav">
                  <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#ecommerce-product-details-5-overview" type="button">Overview</button>
                  <button className="nav-link" data-bs-toggle="tab" data-bs-target="#ecommerce-product-details-5-technical" type="button">Technical Details</button>
                  <button className="nav-link" data-bs-toggle="tab" data-bs-target="#ecommerce-product-details-5-customer-reviews" type="button">Reviews (0)</button>
                </nav>

                <div className="tab-content">
                  {/* <!-- Overview Tab --> */}
                  <div className="tab-pane fade show active" id="ecommerce-product-details-5-overview">
                    <div className="overview-content">
                      <div className="row g-4">
                        <div className="col-lg-8">
                          <div className="content-section">
                            <h3>Product Overview</h3>
                            <p>{pdt.description}</p>
                            {/* <p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.</p> */}

                            <h4>Key Highlights</h4>
                            <div className="highlights-grid">
                              {/* <div className="highlight-card">
                                <i className="bi bi-volume-up"></i>
                                <h5>Superior Audio</h5>
                                <p>Ut enim ad minima veniam quis nostrum exercitationem</p>
                              </div>
                              <div className="highlight-card">
                                <i className="bi bi-battery-charging"></i>
                                <h5>Long Battery</h5>
                                <p>Excepteur sint occaecat cupidatat non proident</p>
                              </div>
                              <div className="highlight-card">
                                <i className="bi bi-wifi"></i>
                                <h5>Wireless Tech</h5>
                                <p>Duis aute irure dolor in reprehenderit in voluptate</p>
                              </div>
                              <div className="highlight-card">
                                <i className="bi bi-person-check"></i>
                                <h5>Comfort Fit</h5>
                                <p>Lorem ipsum dolor sit amet consectetur adipiscing</p>
                              </div> */}
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4">
                          <div className="package-contents">
                            <h4>Package Contents</h4>
                            <ul className="contents-list">
                              {/* <li><i className="bi bi-check-circle"></i>Premium Audio Device</li>
                              <li><i className="bi bi-check-circle"></i>Premium Carrying Case</li>
                              <li><i className="bi bi-check-circle"></i>USB-C Fast Charging Cable</li>
                              <li><i className="bi bi-check-circle"></i>3.5mm Audio Connector</li>
                              <li><i className="bi bi-check-circle"></i>Quick Start Guide</li>
                              <li><i className="bi bi-check-circle"></i>Warranty Documentation</li> */}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <!-- Technical Details Tab --> */}
                  <div className="tab-pane fade" id="ecommerce-product-details-5-technical">
                    <div className="technical-content">
                      <div className="row g-4">
                        <div className="col-md-6">
                          <div className="tech-group">
                            <h4>Audio Specifications</h4>
                            <div className="spec-table">
                              <div className="spec-row">
                                <span className="spec-name">Frequency Range</span>
                                <span className="spec-value">15Hz - 25kHz</span>
                              </div>
                              <div className="spec-row">
                                <span className="spec-name">Driver Diameter</span>
                                <span className="spec-value">50mm Dynamic</span>
                              </div>
                              <div className="spec-row">
                                <span className="spec-name">Sensitivity</span>
                                <span className="spec-value">98dB SPL</span>
                              </div>
                              <div className="spec-row">
                                <span className="spec-name">Impedance</span>
                                <span className="spec-value">24 Ohm</span>
                              </div>
                              <div className="spec-row">
                                <span className="spec-name">THD</span>
                                <span className="spec-value">&lt; 0.5%</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="tech-group">
                            <h4>Connectivity &amp; Power</h4>
                            <div className="spec-table">
                              <div className="spec-row">
                                <span className="spec-name">Wireless Protocol</span>
                                <span className="spec-value">Bluetooth 5.3</span>
                              </div>
                              <div className="spec-row">
                                <span className="spec-name">Range</span>
                                <span className="spec-value">Up to 30ft (10m)</span>
                              </div>
                              <div className="spec-row">
                                <span className="spec-name">Battery Capacity</span>
                                <span className="spec-value">800mAh Li-ion</span>
                              </div>
                              <div className="spec-row">
                                <span className="spec-name">Usage Time</span>
                                <span className="spec-value">35+ hours</span>
                              </div>
                              <div className="spec-row">
                                <span className="spec-name">Charge Time</span>
                                <span className="spec-value">2.5 hours</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="tech-group">
                            <h4>Physical Dimensions</h4>
                            <div className="spec-table">
                              <div className="spec-row">
                                <span className="spec-name">Weight</span>
                                <span className="spec-value">285g</span>
                              </div>
                              <div className="spec-row">
                                <span className="spec-name">Dimensions</span>
                                <span className="spec-value">190 x 165 x 82mm</span>
                              </div>
                              <div className="spec-row">
                                <span className="spec-name">Ear Cup Material</span>
                                <span className="spec-value">Memory Foam</span>
                              </div>
                              <div className="spec-row">
                                <span className="spec-name">Headband</span>
                                <span className="spec-value">Adjustable Steel</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="tech-group">
                            <h4>Advanced Features</h4>
                            <div className="spec-table">
                              <div className="spec-row">
                                <span className="spec-name">Noise Cancellation</span>
                                <span className="spec-value">Hybrid ANC</span>
                              </div>
                              <div className="spec-row">
                                <span className="spec-name">Voice Assistant</span>
                                <span className="spec-value">Siri &amp; Google</span>
                              </div>
                              <div className="spec-row">
                                <span className="spec-name">Microphone Type</span>
                                <span className="spec-value">Dual Array</span>
                              </div>
                              <div className="spec-row">
                                <span className="spec-name">Water Rating</span>
                                <span className="spec-value">IPX5</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <!-- Reviews Tab --> */}
                  <div className="tab-pane fade" id="ecommerce-product-details-5-customer-reviews">
                    <div className="reviews-content">
                      <div className="reviews-header">
                        <div className="rating-overview">
                          <div className="average-score">
                            <div className="score-display">4.6</div>
                            <div className="score-stars">
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-fill"></i>
                              <i className="bi bi-star-half"></i>
                            </div>
                            <div className="total-reviews">127 customer reviews</div>
                          </div>

                          <div className="rating-distribution">
                            <div className="rating-row">
                              <span className="stars-label">5★</span>
                              <div className="progress-container">
                                <div className="progress-fill" style={{"width": "68%"}}></div>
                              </div>
                              <span className="count-label">86</span>
                            </div>
                            <div className="rating-row">
                              <span className="stars-label">4★</span>
                              <div className="progress-container">
                                <div className="progress-fill" style={{"width": "22%"}}></div>
                              </div>
                              <span className="count-label">28</span>
                            </div>
                            <div className="rating-row">
                              <span className="stars-label">3★</span>
                              <div className="progress-container">
                                <div className="progress-fill" style={{"width": "6%"}}></div>
                              </div>
                              <span className="count-label">8</span>
                            </div>
                            <div className="rating-row">
                              <span className="stars-label">2★</span>
                              <div className="progress-container">
                                <div className="progress-fill" style={{"width": "3%"}}></div>
                              </div>
                              <span className="count-label">4</span>
                            </div>
                            <div className="rating-row">
                              <span className="stars-label">1★</span>
                              <div className="progress-container">
                                <div className="progress-fill" style={{"width": "1%"}}></div>
                              </div>
                              <span className="count-label">1</span>
                            </div>
                          </div>
                        </div>

                        <div className="write-review-cta">
                          <h4>Share Your Experience</h4>
                          <p>Help others make informed decisions</p>
                          <button className="btn review-btn">Write Review</button>
                        </div>
                      </div>

                      <div className="customer-reviews-list">
                        <div className="review-card">
                          <div className="reviewer-profile">
                            <img src="assets/img/person/person-f-3.webp" alt="Customer" className="profile-pic" />
                            <div className="profile-details">
                              <div className="customer-name">Sarah Martinez</div>
                              <div className="review-meta">
                                <div className="review-stars">
                                  <i className="bi bi-star-fill"></i>
                                  <i className="bi bi-star-fill"></i>
                                  <i className="bi bi-star-fill"></i>
                                  <i className="bi bi-star-fill"></i>
                                  <i className="bi bi-star-fill"></i>
                                </div>
                                <span className="review-date">March 28, 2024</span>
                              </div>
                            </div>
                          </div>
                          <h5 className="review-headline">Outstanding audio quality and comfort</h5>
                          <div className="review-text">
                            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam. Eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
                          </div>
                          <div className="review-actions">
                            <button className="action-btn"><i className="bi bi-hand-thumbs-up"></i> Helpful (12)</button>
                            <button className="action-btn"><i className="bi bi-chat-dots"></i> Reply</button>
                          </div>
                        </div>

                        <div className="review-card">
                          <div className="reviewer-profile">
                            <img src="assets/img/person/person-m-5.webp" alt="Customer" className="profile-pic" />
                            <div className="profile-details">
                              <div className="customer-name">David Chen</div>
                              <div className="review-meta">
                                <div className="review-stars">
                                  <i className="bi bi-star-fill"></i>
                                  <i className="bi bi-star-fill"></i>
                                  <i className="bi bi-star-fill"></i>
                                  <i className="bi bi-star-fill"></i>
                                  <i className="bi bi-star"></i>
                                </div>
                                <span className="review-date">March 15, 2024</span>
                              </div>
                            </div>
                          </div>
                          <h5 className="review-headline">Great value, minor connectivity issues</h5>
                          <div className="review-text">
                            <p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Overall satisfied with the purchase.</p>
                          </div>
                          <div className="review-actions">
                            <button className="action-btn"><i className="bi bi-hand-thumbs-up"></i> Helpful (8)</button>
                            <button className="action-btn"><i className="bi bi-chat-dots"></i> Reply</button>
                          </div>
                        </div>

                        <div className="review-card">
                          <div className="reviewer-profile">
                            <img src="assets/img/person/person-f-7.webp" alt="Customer" className="profile-pic" />
                            <div className="profile-details">
                              <div className="customer-name">Emily Rodriguez</div>
                              <div className="review-meta">
                                <div className="review-stars">
                                  <i className="bi bi-star-fill"></i>
                                  <i className="bi bi-star-fill"></i>
                                  <i className="bi bi-star-fill"></i>
                                  <i className="bi bi-star-fill"></i>
                                  <i className="bi bi-star-fill"></i>
                                </div>
                                <span className="review-date">February 22, 2024</span>
                              </div>
                            </div>
                          </div>
                          <h5 className="review-headline">Perfect for work-from-home setup</h5>
                          <div className="review-text">
                            <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident.</p>
                          </div>
                          <div className="review-actions">
                            <button className="action-btn"><i className="bi bi-hand-thumbs-up"></i> Helpful (15)</button>
                            <button className="action-btn"><i className="bi bi-chat-dots"></i> Reply</button>
                          </div>
                        </div>

                        <div className="load-more-section">
                          <button className="btn load-more-reviews">Show More Reviews</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </section>
      {/* <!-- /Product Details Section --> */}
      {/* <script src="/build/js/niceshop/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
      <script src="/build/js/niceshop/vendor/php-email-form/validate.js"></script>
      <script src="/build/js/niceshop/vendor/swiper/swiper-bundle.min.js"></script>
      <script src="/build/js/niceshop/vendor/aos/aos.js"></script>
      <script src="/build/js/niceshop/vendor/glightbox/js/glightbox.min.js"></script>
      <script src="/build/js/niceshop/vendor/drift-zoom/Drift.min.js"></script>
      <script src="/build/js/niceshop/vendor/purecounter/purecounter_vanilla.js"></script>    */}
  </>
}

export default function ProductDetails(){
    
    return <PdtsProvider><Layout>
      <ProductDetailsContent></ProductDetailsContent>
    </Layout></PdtsProvider>
}